<script setup>
import { ref } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import CourseRecap from '@/components/dashboard/cards/course-recap.vue';

const showRecap = ref(false);
</script>

<template>
    <div
        v-if="!showRecap"
        class="col-span-12 lg:col-span-6 overflow-hidden shadow rounded-lg bg-white relative"
    >
        <div
            class="rounded-lg p-6 relative flex flex-col justify-between h-full"
            style="min-height: 320px"
        >
            <Icon
                icon="win"
                class="absolute top-[6px] left-1/2 transform -translate-x-1/2"
            />
            <div class="flex flex-row items-center justify-between w-full">
                <div class="flex flex-row gap-2 items-center">
                    <Icon icon="courses" class="text-slate-800" />
                    <div class="text-slate-800 text-lg font-medium">
                        10x Course
                    </div>
                </div>
                <a
                    href="/course/"
                    class="flex items-center text-sm font-medium rounded text-slate-800 hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                >
                    View details
                    <Icon icon="arrow" />
                </a>
            </div>
            <div
                class="text-center font-inter text-3xl font-medium leading-9 mt-36"
            >
                <div class="text-orange">Congratulations!</div>
                <div class="text-slate-800">You’ve finished the course.</div>
            </div>
            <button
                @click="showRecap = true"
                class="inline-flex px-4 py-2 mt-4 mx-auto justify-center items-center gap-2 rounded-md bg-[var(--Primary-10x-Orange,#FD421D)] text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
            >
                Great, got it!
            </button>
        </div>
    </div>
    <CourseRecap v-else />
</template>
